export const echartsGet = "/sys/echarts";//echarts图表

export const echartsPayGet = "/sys/echarts/payRate";//付费率
export const echartsUserGet = "/sys/echarts/user";//日新增用户